import React from "react";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";

export const tableConstants = (permissions, notificationDelete) => {
  let count = 1;
  let formatedData = [
    {
      title: 'SNo',
      render: () => {
        return <span>{count++}</span>;
      },
    },
    {
      title: 'IdNumber',
      render: rowData => {
        return <span>{rowData.student.id_number}</span>;
      },
    },
    {
      title: 'Name',
      render: rowData => {
        return <span>{rowData.student.first_name+' '+rowData.student.last_name}</span>;
      },
    },
     {
      title: 'Type',
      render: rowData => {
        return <span>{rowData.type}</span>;
      },
    },
    {
      title: 'Description',
      render: rowData => {
        // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
        return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(rowData.message) }} />;
      },
    },
    {
      title: 'Action',
      render: rowData => {
        return <span>
          {permissions.includes('notification.update') &&
            <Link to={`/notification/update/${rowData.id}`}>
              <FontAwesomeIcon
                icon={faEdit}
                style={{
                  color: "var(--color-primary-text)",
                  marginRight: "10px",
                  cursor: "pointer"
                }}
              />
            </Link>
          }
          &nbsp;
          {permissions.includes("notification.delete") &&
            <span
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm(`Are you sure you wish to delete this item?`))
                  notificationDelete(rowData.id)
              }}>
              <i className="fa fa-trash text-danger"></i>
            </span>
          }
        </span>;
      },
    },
  ];
  return formatedData;
};
